<template>
  <el-aside>
    <el-row class="tac">
      <el-menu
        default-active="1"
        :collapse="isCollapse" ref="menu">
        
        <el-menu-item class="logo no-hover" placement="top" @click="openLikezoidSite" />

        <el-tooltip content="Redeem Free Likes" placement="left" :disabled="!isCollapse">
          <el-menu-item index="1" @click="navigate(Pages.Redeem)">
            <i class="lz-icon-folder"></i>
            <span>Redeem Free Likes</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip v-if="1 === '2'" content="Settings" placement="left" :disabled="!isCollapse">
          <el-menu-item index="3" @click="navigate(Pages.Settings)">
            <i class="lz-icon-setting"></i>
            <span>Settings</span>
          </el-menu-item>
        </el-tooltip>
        
        <el-tooltip content="Accounts" placement="left" :disabled="!isCollapse">
          <el-menu-item index="4" @click="navigate(Pages.Accounts)">
            <i class="lz-icon-account"></i>
            <span>Accounts</span>
            <el-badge v-if="hasAccountError" :value="isCollapse ? '!' : 'Error!'" class="item" type="danger"></el-badge>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="Orders" placement="left" :disabled="!isCollapse">
          <el-menu-item index="5" @click="navigate(Pages.Orders)">
              <i class="lz-icon-orders"></i>
              <span>Orders</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="Gold History" placement="left" :disabled="!isCollapse">
          <el-menu-item index="6" @click="navigate(Pages.GoldHistory)">
            <i class="lz-icon-gold"></i>
            <span>Gold History</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip content="FAQ" placement="left" :disabled="!isCollapse">
          <el-menu-item index="7" @click="navigate(Pages.FAQ)">
            <i class="lz-icon-faq"></i>
            <span>FAQ</span>
          </el-menu-item>
        </el-tooltip>

        <!-- <el-tooltip content="News" placement="left" :disabled="!isCollapse">
          <el-menu-item index="8" @click="navigate(Pages.News)">
            <i class="lz-icon-news"></i>
            <span>News</span>
          </el-menu-item>
        </el-tooltip> -->

        <el-tooltip :content="isCollapse ? 'Expand Menu' : 'Collapse Menu'" placement="left" :disabled="!isCollapse">
          <el-menu-item @click="isCollapse = !isCollapse">
            <i v-if="!isCollapse" class="el-icon-d-arrow-left"></i>
            <i v-else class="el-icon-d-arrow-right"></i>
            <span>Collapse</span>
          </el-menu-item>
        </el-tooltip>

        <el-menu-item class="divider bottom-divider" placement="bottom" />

        <el-tooltip content="Support" placement="bottom" :disabled="!isCollapse">
          <el-menu-item class="support" index="8" @click="openLikezoidSupport">
            <!-- <i v-if="isCollapse" class="el-icon-phone"></i> -->
            <span else>Help &amp; Support</span>
          </el-menu-item>
        </el-tooltip>
      </el-menu>
    </el-row>
  </el-aside>
</template>

<script>
import { BridgeAPI } from '@/bridge'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  data () {
    return {
      isCollapse: false,
    }
  },
  computed: {
    ...mapGetters([
      'currentPage',
      'Pages',
      'allAccounts'
    ]),
    hasAccountError () {
      return this.allAccounts.filter(a => (a.needsLogin && a.needsLogin === true) || (a.likeBlocked && a.likeBlocked === true)).length;
    }
  },
  methods: {
    openLikezoidSupport: () => {
      BridgeAPI.openLink('https://likezoid.com/support/');
    },
    openLikezoidSite: () => {
      BridgeAPI.openLink('https://likezoid.com/');
    },
    ...mapActions({
      navigate: 'changePage'
    }),
  }
}
</script>

<style lang="scss">
.el-aside {
  width: auto !important;
  overflow: hidden !important;

  .el-menu {
    position: relative;

    .el-menu-item {
      margin: 0 14px;
      color: #9495a4;
      font-weight: 500;
      line-height: 32px;
      border-radius: 5px;

      i {
        margin-right: 21px;
      }

      &.logo {
        margin: 25px 20px 72px;
        padding: 0 !important;
        width: 26px;
        height: 26px;

        &:before {
          content: '';
          display: block;
          width: 26px;
          height: 26px;
          background-image: url('../assets/img/logo.svg');
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
      }

      &:not(.divider):not(.logo) {
        padding: 9px 6px !important;
      }

      &.divider {
        margin: 0;
        height: 1px;
        background: #ededed;

        &.bottom-divider {
          position: absolute;
          bottom: 83px;
          width: 100%;
        }
      }

      &.support {
        position: absolute;
        margin-top: 11px;
        margin-bottom: 16px;
        bottom: 0;
        width: calc(100% - 28px);
        color: #8652f6;
        background: #fff;
        box-shadow: 0px 1px 3px rgba(50, 59, 91, 0.12);
        text-align: center;

        &:before {
          content: '';
          display: inline-block;
          margin-right: 10px;
          width: 19px;
          height: 19px;
          background-image: url('../assets/img/help.svg');
          vertical-align: middle;
        }
      }

      &:active,
      &.is-active {
        color: #4a4b58;
        background: #f8f9fA;
      }

      &:hover {
        color: #4a4b58;
        background: #f2f1f3;
      }
    }

    &.el-menu--collapse .el-menu-item {
      text-align: center;

      i {
        margin-right: 0;
      }
    }
    
    &:not(.el-menu--collapse) {
      width: 276px;
      
      .el-menu-item {
        &:not(.divider):not(.logo) {
          padding-left: 14px !important;
          padding-right: 14px !important;
        }

        &.logo {
          margin-left: 39px;
          margin-right: 39px;

          &:before {
            width: 126px;
            background-image: url('../assets/img/logo-name.svg');
          }
        }
      }
    }
  }
}

.item {
  position: relative;
  top: -10px;
  margin-top: 0px;
  margin-right: 40px;
}

.no-hover {
  &:hover {
    background: none !important;
  }
}
</style>
